/**
 * AttributeFramingSequence.tsx - Sequence configuration for the Attribute Framing experiment
 * Last updated: 2025-08-12 11:17:53
 * Updated by: JulianPolly
 */

import { useSession } from "../../../SessionContext";
import { useLanguage } from "../../../../context/LanguageContext";
import { ScreenSequence } from "../Sequences";
import { AttributeScreen1Config } from "./AttributeScreen1";
import { ExplainationScreen } from "./ExplanationScreen";
import { ResultScreen } from "./ResultScreen";
// import { ResultScreenGlobal } from "./ResultScreenGlobal";
import { WellDoneScreen } from "../../../WellDoneScreen";
import { experiments } from "../../../../translations/experiments";

// Export this constant for use in the Sequences.tsx file
export const AttributeFramingKey = "AttributeFraming";

/**
 * Hook to get the Attribute Framing experiment sequence with translations
 * Uses the language context to provide translated content
 */
export function useAttributeFramingSequence(): ScreenSequence {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { userData } = useSession();
    const { t } = useLanguage();

    // In the future, we could use userData to show different versions
    // For example: if (userData?.randomizer4 === "Condition B") { ... }

    return {
        name: t('experiments', 'attributeFraming', 'title'),
        description: t('experiments', 'attributeFraming', 'description'),
        group: "A1",
        screens: [
            { component: AttributeScreen1Config.component },
            { component: ResultScreen.component },
            { component: ExplainationScreen.component },
            // { component: ResultScreenGlobal.component },
            {
                component: WellDoneScreen,
                canContinueDefault: false,  // Nur hier!
            }
        ],
        resultScreenIndex: 1,
        explanationScreenIndex: 2,
    };
}

// Get the current locale's translations for static use
// This will default to 'de' if we're in a non-React context
const attributeFramingTranslations = experiments.attributeFraming.de;

// Export the static sequence for use in Sequences.tsx
// Use the translations instead of hardcoded values
export const AttributeFramingSequence: ScreenSequence = {
    name: attributeFramingTranslations.title,
    description: attributeFramingTranslations.description,
    group: "A1",
    screens: [
        { component: AttributeScreen1Config.component },
        { component: ResultScreen.component },
        { component: ExplainationScreen.component },
        // { component: ResultScreenGlobal.component },
        {
            component: WellDoneScreen,
            canContinueDefault: false,  // Nur hier!
        }
    ],
    resultScreenIndex: 1,
    explanationScreenIndex: 2,
};